import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { CommodityDuty } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CommodityDutyService extends TmsWebBaseEditCreateService<CommodityDuty, CommodityDuty> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('CommodityDuty', $localize`Commodity Duty`);
  }

  getForCommodityCode(commodityCodeId: string): Observable<CommodityDuty[]> {
    return this.httpService.get<CommodityDuty[]>(`${this.apiUrl}/GetForCommodityCode?id=${commodityCodeId}`);
  }
}
